import { fabric } from 'fabric';

import { Diagram } from 'model/Diagram';

export const getMinRatio = (section: Diagram, img: Diagram): number => {
  const widthRatio = section.width / img.width;
  const heightRatio = section.height / img.height;

  return Math.min(widthRatio, heightRatio);
}

export const enablePanningAndZoom = (canvas: fabric.Canvas, useAlt: boolean = false) => {
  let isDragging = false;
  let lastX: number = 0;
  let lastY: number = 0;


  canvas.on('mouse:down', event => {
    if ((!useAlt && !event.target) || (useAlt && event.e.altKey)) {
      lastX = event.e.clientX;
      lastY = event.e.clientY;
      isDragging = true;
    }
  });

  canvas.on('mouse:move', event => {
    if (!isDragging) return;

    const pointer = canvas.getPointer(event.e);
    lastX = pointer.x;
    lastY = pointer.y;

    const delta = new fabric.Point(event.e.movementX, event.e.movementY);
    canvas?.relativePan(delta);
  });

  canvas.on('mouse:up', () => {
    isDragging = false;
  });

  canvas.on('mouse:wheel', opt => {
    // delta는 마우스 휠의 회전량
    const delta = opt.e.deltaY;
    let zoom = canvas.getZoom();
    // 마우스 휠의 zoom을 부드럽게 하기 위해서 1에 가깝게 진행
    zoom *= 0.999 ** delta;
    if (zoom > 20) zoom = 20;
    if (zoom <= 1) zoom = 1;
    canvas.zoomToPoint({ x: opt.e.offsetX, y: opt.e.offsetY }, zoom);
    opt.e.preventDefault();
    opt.e.stopPropagation();

    // zoom이 1로 돌아왔을 때 원래자리로 오게
    const vpt = canvas.viewportTransform!;
    const canvasW = canvas.getWidth();
    const canvasH = canvas.getHeight();
    if (vpt && zoom === 1) {
      if (zoom < 400 / canvasW) {
        vpt[4] = 200 - (canvasW * zoom) / 2;
        vpt[5] = 200 - (canvasW * zoom) / 2;
      } else {
        if (vpt[4] >= 0) {
          vpt[4] = 0;
        } else if (vpt[4] < canvas.getWidth() - canvasW * zoom) {
          vpt[4] = canvas.getWidth() - canvasW * zoom;
        }
        if (vpt[5] >= 0) {
          vpt[5] = 0;
        } else if (vpt[5] < canvas.getHeight() - canvasH * zoom) {
          vpt[5] = canvas.getHeight() - canvasH * zoom;
        }
      }
    }
  });
  // return () => {
  //   canvas.dispose();
  // };
}

export const clearCanvas = (canvas: fabric.Canvas | undefined) => {
  if (!canvas || !canvas.getContext()) {
    return;
  }

  canvas.clear();
};